export const initializeSpeakingWeb = () => {
  const browsealoudScript = document.createElement("script");

  browsealoudScript.setAttribute("type", "text/javascript");
  browsealoudScript.setAttribute("src", "https://www.browsealoud.com/plus/scripts/3.1.0/ba.js");
  browsealoudScript.setAttribute("crossorigin", "anonymous");
  browsealoudScript.setAttribute("integrity", "sha256-VCrJcQdV3IbbIVjmUyF7DnCqBbWD1BcZ/1sda2KWeFc= sha384-k2OQFn+wNFrKjU9HiaHAcHlEvLbfsVfvOnpmKBGWVBrpmGaIleDNHnnCJO4z2Y2H sha512-gxDfysgvGhVPSHDTieJ/8AlcIEjFbF3MdUgZZL2M5GXXDdIXCcX0CpH7Dh6jsHLOLOjRzTFdXASWZtxO+eMgyQ==");

  document.body.appendChild(browsealoudScript);
};
